module.exports = __webpack_public_path__ + "img/stripeGrabLogo.d8651a4b.png";